import React from 'react'
import clsx from 'clsx'
import { Box, Table, TableBody, TableHead } from '@mui/material'
import { CalculationTableBodyCellSize } from 'src/components/atoms'
import CalculationTableBodyRow, {
  Cell as LeftTableCell,
} from 'src/components/molecules/CalculationTableBodyRow'
import CalculationTableHeaderRow, {
  Cell as HeaderCell,
} from 'src/components/molecules/CalculationTableHeaderRow'
import { Option } from 'src/components/molecules/SelectWithOption'
import { injectIndex } from 'src/utils/array'
import { isOdd } from 'src/utils/number'
import EditFormatRightBodyRow, {
  SelectCell,
  InputCell,
} from '../EditFormatRightBodyRow'
import styles from './styles.module.scss'

export type BodyRow = {
  number: string
  calculationItemName: string
  readItemName: string
  selectCells: SelectCell[]
  inputCell: InputCell
  showInput: boolean
}

export type EditOCRFormatTableProps = {
  columns: HeaderCell[]
  rows: BodyRow[]
  onChangeSelect: (option: Option, rowIndex: number, name: string) => void
} & React.StyledProps

const EditOCRFormatTable: React.StyledFC<EditOCRFormatTableProps> = ({
  className,
  columns,
  rows,
  onChangeSelect,
}: EditOCRFormatTableProps) => {
  const convertedLeftTableCell = (row: BodyRow): LeftTableCell[] => {
    const cells = [
      {
        text: row.number,
        size: 'medium' as CalculationTableBodyCellSize,
      },
      {
        text: row.calculationItemName,
        size: 'large' as CalculationTableBodyCellSize,
      },
      {
        text: row.readItemName,
        size: 'large' as CalculationTableBodyCellSize,
      },
    ]
    return injectIndex(cells)
  }

  return (
    <Box className={clsx(className, styles.root)}>
      <Box className={styles.leftTableWrapper}>
        <Table stickyHeader className={styles.leftTable}>
          <TableHead>
            <CalculationTableHeaderRow cells={columns.slice(0, 3)} />
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <CalculationTableBodyRow
                className={styles.tableBodyRow}
                key={row.number}
                cells={convertedLeftTableCell(row)}
                isGray={isOdd(rowIndex)}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box className={styles.rightTableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <CalculationTableHeaderRow cells={columns.slice(3)} />
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <EditFormatRightBodyRow
                className={styles.tableBodyRow}
                key={row.number}
                selectCells={row.selectCells}
                inputCell={row.inputCell}
                isGray={isOdd(rowIndex)}
                showInput={row.showInput}
                onChangeSelect={(option, name) =>
                  onChangeSelect(option, rowIndex, name)
                }
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  )
}

export default EditOCRFormatTable
